import { combineReducers } from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";

// import { interviewReducer } from "../areas/interview/state/reducer";
import { authReducer } from "../areas/auth/state/reducer";
import { frameReducer } from "../areas/frame/state/reducer";
import { profileReducer } from "../areas/profile/state/reducer";

import { configReducer } from "./config/reducer";
import { loadingReducer } from "./loading/reducer";
import { snackReducer } from "./snack/reducer";

export const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
  // other options if needed
});

export const webUiV2ReducerSlices = {
  router: routerReducer,
  authV2: authReducer,
  config: configReducer,
  frame: frameReducer,
  profile: profileReducer,
  loading: loadingReducer,
  snack: snackReducer,
  // interview: interviewReducer,
};

export const createRootReducer = () => combineReducers(webUiV2ReducerSlices);

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;
